<template>
	<div class="PageMediaStore">
		<div class="row" v-for="chunked_asset in chunk(assets, 4)">

			<div v-if="chunked_asset" v-for="(asset, index) in chunked_asset" :key="index" @click="active = asset.id" class="col-xs-12 col-sm-6 col-md-3">
				<div v-if="asset && asset.id" class="mediabox" :class="{'mediabox--active': active == asset.id, 'mediabox--not-embeded': asset.pages.length <= 0}">

					<div v-if="asset.height && asset.width">{{ asset.height }}x{{ asset.width }}</div>
					<img v-if="asset.type == 'image' || asset.ext == 'jpg' || asset.ext == 'jpeg' || asset.ext == 'png' || asset.ext == 'gif' || asset.ext == 'svg'" :src="asset.url" :alt="asset.basename" />
					<img v-else-if="asset.preview" :src="asset.preview" :alt="asset.basename" />
					<strong class="st-headline st-headline--1" v-else>{{ asset.ext }}</strong>
					<div class="mediabox__content">
						<small>
							<strong>{{ asset.basename }}</strong>

							<div v-if="asset.owner">Owner: {{ asset.owner.fancyname }}</div>

							<a  class="st-btn st-btn--primary st-btn--small" download :href="asset.url">Download</a>
							<button v-if="asset.pages.length <= 0" @click="deleteAsset(asset.id)" class="st-btn st-btn--highlight st-btn--small">Delete</button>
							<div><span v-for="id in asset.pages">{{ id }}</span></div>
						</small>

						<div class="row"  v-if="asset.variations">
							<div class="col-xs-6" v-for="variation in asset.variations">
								<strong>{{ variation.basename }}</strong>
								<div>{{ variation.height }}x{{ variation.width }}</div>
								<img :src="variation.url" :alt="variation.basename" />
								<a download :href="variation.url">Download {{ variation.basename }}</a>
							</div>
						</div>
					</div>
				</div>
				<div v-else>
					<pre>{{ asset }}</pre>
					<pre>{{ index }}</pre>
				</div>
				<!--<CroppableImage v-if="active == asset.id" :assetID="active" :width="1600" :height="900"></CroppableImage>-->
			</div>
		</div>
	</div>
</template>

<script>
import chunk from 'lodash/chunk';

import FieldForm from '@/components/form/FieldForm';
import help_rest from '@/helpers/rest';
import CroppableImage from '@/components/CroppableImage';
import forEach from 'lodash/forEach';

export default {
	name: 'PageMediaStore',
	components: {CroppableImage},
	data(){
		return {
			active: false,
			assets: []
		};
	},
	mounted(){
		this.init();
	},
	methods: {
		deleteAsset(aid){
			var self = this;
			self.restdelete('/api/v1/assets/' + aid, 'deleteAsset')
			.then(message => {
				forEach(self.assets, (asset, index) => {
					if(asset && asset.id == aid){
						self.assets.splice(index, 1);
					}
				})
			});
		},
		chunk: chunk,
		...help_rest,
		init(){
			var self = this;
			self.restget('/api/v1/assets/', 'media_store')
			.then(message => {
				self.assets = message ;
			});
		}
	}
}
</script>

<style scoped>
.mediabox {
    border: 1px solid #3e4c572e;
    margin-bottom: 30px;

    cursor: pointer;
}
.mediabox--not-embeded {
	background: #f7ffde;
}
.mediabox {
	display: block;
}
.mediabox strong {
    word-break: break-all;
}
.mediabox__content {
	padding: 12px;
}
.mediabox--active {
    background: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/pages/PageMediaStore.vue